export function ProgressBar({
  value,
  title
}: {
  value: number
  title?: string
}) {
  return (
    <div
      className="relative w-full rounded overflow-hidden h-6 bg-text-light"
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="absolute bg-primary left-0 inset-y-0 transition-width"
        style={{
          width: `${value}%`
        }}
      />
      <span className="absolute text-small text-white font-bold left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        {title ? `${title}: ${value}%` : null}
      </span>
    </div>
  )
}
